import ScoutMetricCard from "./cards/ScoutMetricCard";
import ScoutChartCard from "./cards/ScoutChartCard";
import ScoutEmissionsChart from "./cards/ScoutEmissionsChart";
import ScoutListCard from "./cards/ScoutListCard";
import ScoutNavigateCard from "./cards/ScoutNavigateCard";
import ScoutActionCard from "./cards/ScoutActionCard";

export const cardRegistry = {
  metric_card: ScoutMetricCard,
  chart_card: ScoutChartCard,
  emissions_chart: ScoutEmissionsChart,
  list_card: ScoutListCard,
  navigate_card: ScoutNavigateCard,
  action_card: ScoutActionCard
};
